import {JobEventApiDto, JobFilesAttachedEventDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import Attachment from "../../attachment/Attachment";
import {default as JobEvent, JobEventTypeEnum} from "./JobEvent";
import moment = require("moment");
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";

export default class JobFilesAttachedEvent extends JobEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} jobId job id.
	 * @param {JobEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber job reference number.
	 * @param data job files attached files event data
	 */
	constructor(public readonly id: string,
		public readonly jobId: string,
		public readonly type: JobEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: JobFilesAttachedEventData) {
		super(id, jobId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: JobEventApiDto): JobFilesAttachedEvent {
		const data = JobFilesAttachedEventData.fromJson(json.data as JobFilesAttachedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new JobFilesAttachedEvent(json.id,
			json.jobId,
			JobEventTypeEnum.JobFilesAttached,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.File;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getAttachments(): Attachment[] {
		return this.data.attachments;
	}

	getActivityMessage(): string {
		return "Files added";
	}
}

export class JobFilesAttachedEventData {
	constructor(public readonly attachments: Attachment[]) {}

	public static fromJson(json: JobFilesAttachedEventDataApiDto): JobFilesAttachedEventData {
		return new JobFilesAttachedEventData(json.attachments.map(Attachment.fromJson));
	}
}
